var _classCallCheck = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _get = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/vsts/work/1/s/wwwroot/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Generated by CoffeeScript 2.4.1
(function () {
  var NodeType, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNamedNodeMap, XMLNode, isObject;
  var _require = require('./Utility');
  isObject = _require.isObject;
  XMLNode = require('./XMLNode');
  NodeType = require('./NodeType');
  XMLDTDAttList = require('./XMLDTDAttList');
  XMLDTDEntity = require('./XMLDTDEntity');
  XMLDTDElement = require('./XMLDTDElement');
  XMLDTDNotation = require('./XMLDTDNotation');
  XMLNamedNodeMap = require('./XMLNamedNodeMap');

  // Represents doctype declaration
  module.exports = XMLDocType = function () {
    var XMLDocType = /*#__PURE__*/function (_XMLNode) {
      "use strict";

      _inherits(XMLDocType, _XMLNode);
      var _super = _createSuper(XMLDocType);
      // Initializes a new instance of `XMLDocType`

      // `parent` the document object

      // `pubID` public identifier of the external subset
      // `sysID` system identifier of the external subset
      function XMLDocType(parent, pubID, sysID) {
        var _this;
        _classCallCheck(this, XMLDocType);
        var child, i, len, ref;
        _this = _super.call(this, parent);
        _this.type = NodeType.DocType;
        // set DTD name to the name of the root node
        if (parent.children) {
          ref = parent.children;
          for (i = 0, len = ref.length; i < len; i++) {
            child = ref[i];
            if (child.type === NodeType.Element) {
              _this.name = child.name;
              break;
            }
          }
        }
        _this.documentObject = parent;
        // arguments may also be passed as an object
        if (isObject(pubID)) {
          var _pubID = pubID;
          pubID = _pubID.pubID;
          sysID = _pubID.sysID;
        }
        if (sysID == null) {
          var _ref = [pubID, sysID];
          sysID = _ref[0];
          pubID = _ref[1];
        }
        if (pubID != null) {
          _this.pubID = _this.stringify.dtdPubID(pubID);
        }
        if (sysID != null) {
          _this.sysID = _this.stringify.dtdSysID(sysID);
        }
        return _this;
      }

      // Creates an element type declaration

      // `name` element name
      // `value` element content (defaults to #PCDATA)
      _createClass(XMLDocType, [{
        key: "element",
        value: function element(name, value) {
          var child;
          child = new XMLDTDElement(this, name, value);
          this.children.push(child);
          return this;
        }

        // Creates an attribute declaration

        // `elementName` the name of the element containing this attribute
        // `attributeName` attribute name
        // `attributeType` type of the attribute (defaults to CDATA)
        // `defaultValueType` default value type (either #REQUIRED, #IMPLIED, #FIXED or
        //                    #DEFAULT) (defaults to #IMPLIED)
        // `defaultValue` default value of the attribute
        //                (only used for #FIXED or #DEFAULT)
      }, {
        key: "attList",
        value: function attList(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
          var child;
          child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
          this.children.push(child);
          return this;
        }

        // Creates a general entity declaration

        // `name` the name of the entity
        // `value` internal entity value or an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        // `value.nData` notation declaration
      }, {
        key: "entity",
        value: function entity(name, value) {
          var child;
          child = new XMLDTDEntity(this, false, name, value);
          this.children.push(child);
          return this;
        }

        // Creates a parameter entity declaration

        // `name` the name of the entity
        // `value` internal entity value or an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
      }, {
        key: "pEntity",
        value: function pEntity(name, value) {
          var child;
          child = new XMLDTDEntity(this, true, name, value);
          this.children.push(child);
          return this;
        }

        // Creates a NOTATION declaration

        // `name` the name of the notation
        // `value` an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
      }, {
        key: "notation",
        value: function notation(name, value) {
          var child;
          child = new XMLDTDNotation(this, name, value);
          this.children.push(child);
          return this;
        }

        // Converts to string

        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
      }, {
        key: "toString",
        value: function toString(options) {
          return this.options.writer.docType(this, this.options.writer.filterOptions(options));
        }

        // Aliases
      }, {
        key: "ele",
        value: function ele(name, value) {
          return this.element(name, value);
        }
      }, {
        key: "att",
        value: function att(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
          return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
        }
      }, {
        key: "ent",
        value: function ent(name, value) {
          return this.entity(name, value);
        }
      }, {
        key: "pent",
        value: function pent(name, value) {
          return this.pEntity(name, value);
        }
      }, {
        key: "not",
        value: function not(name, value) {
          return this.notation(name, value);
        }
      }, {
        key: "up",
        value: function up() {
          return this.root() || this.documentObject;
        }
      }, {
        key: "isEqualNode",
        value: function isEqualNode(node) {
          if (!_get(_getPrototypeOf(XMLDocType.prototype), "isEqualNode", this).call(this, node)) {
            return false;
          }
          if (node.name !== this.name) {
            return false;
          }
          if (node.publicId !== this.publicId) {
            return false;
          }
          if (node.systemId !== this.systemId) {
            return false;
          }
          return true;
        }
      }]);
      return XMLDocType;
    }(XMLNode);
    ;

    // DOM level 1
    Object.defineProperty(XMLDocType.prototype, 'entities', {
      get: function get() {
        var child, i, len, nodes, ref;
        nodes = {};
        ref = this.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          if (child.type === NodeType.EntityDeclaration && !child.pe) {
            nodes[child.name] = child;
          }
        }
        return new XMLNamedNodeMap(nodes);
      }
    });
    Object.defineProperty(XMLDocType.prototype, 'notations', {
      get: function get() {
        var child, i, len, nodes, ref;
        nodes = {};
        ref = this.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          if (child.type === NodeType.NotationDeclaration) {
            nodes[child.name] = child;
          }
        }
        return new XMLNamedNodeMap(nodes);
      }
    });

    // DOM level 2
    Object.defineProperty(XMLDocType.prototype, 'publicId', {
      get: function get() {
        return this.pubID;
      }
    });
    Object.defineProperty(XMLDocType.prototype, 'systemId', {
      get: function get() {
        return this.sysID;
      }
    });
    Object.defineProperty(XMLDocType.prototype, 'internalSubset', {
      get: function get() {
        throw new Error("This DOM method is not implemented." + this.debugInfo());
      }
    });
    return XMLDocType;
  }.call(this);
}).call(this);